import React from "react";
import { useNavigate } from "react-router-dom";
import chat from "../assets/images/chat.png";
import income_expense from "../assets/images/income_expense.png";
import debt_solution from "../assets/images/debt_solution.png";
import { useDispatch, useSelector } from "react-redux";
import { setWelcomeDone } from "../slice/userSlice";

const Welcome = () => {
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  console.log(user);
  const navigate = useNavigate();
  const goToSteps = () => {
    dispatch(setWelcomeDone(true));
    navigate("/steps", { replace: true });
  };
  return (
    <>
      <>
        <div>
          <div className="mb-3">
            <h2>
              Hello <span className="fw-bold">{user?.Full_Name}</span>, Check
              your eligibility
            </h2>
            <p>
              Take the followig three steps towards a stress-free life. Find out
              if you qualify for our tailored debt solutions designed to help
              you become debt-free.
            </p>
          </div>

          <h2 className="mb-4">Let's get started with three simple steps</h2>

          <div className="welcome-grid pt-2">
            <div className="welcome-grid-box1 welcome-grid-box">
              <div className="step-number">
                <h1>1</h1>
              </div>
              <h2>Share your Debts</h2>
              <div className="welcome-image">
                <img src={chat} alt="" />
              </div>
              <p>
                Provide us with information about your current debts. This helps
                us understand your situation and tailor a solution that fits
                your needs.
              </p>
            </div>
            <div className="welcome-grid-box2">
              <div className="arrow1-box"></div>
            </div>
            <div className="welcome-grid-box3 welcome-grid-box">
              <div className="step-number">
                <h1>2</h1>
              </div>
              <h2>Outline your Income & Expense</h2>
              <div className="welcome-image">
                <img src={income_expense} alt="" />
              </div>
              <p>
                Provide us with information about your current debts. This helps
                us understand your situation and tailor a solution that fits
                your needs.
              </p>
            </div>
            <div className="welcome-grid-box4">
              <div className="arrow1-box arrow-flipped"></div>
            </div>
            <div className="welcome-grid-box5 welcome-grid-box">
              <div className="step-number">
                <h1>3</h1>
              </div>
              <h2>Explore your Debt Solutions</h2>
              <div className="welcome-image">
                <img src={debt_solution} alt="" />
              </div>
              <p>
                Provide us with information about your current debts. This helps
                us understand your situation and tailor a solution that fits
                your needs.
              </p>
            </div>
          </div>

          <div className="text-center">
            <button
              className="secondary-button welcome-page-button mt-3"
              id="welcome"
              onClick={goToSteps}
            >
              Proceed
            </button>
          </div>
        </div>
      </>
    </>
  );
};

export default Welcome;
